import React from "react";

export const AppIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 16 16"
      fill="none"
    >
      <g fill="currentColor">
        <path d="M7 1a1 1 0 0 0-1-1H2a2 2 0 0 0-2 2v6a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1zM1 11a1 1 0 0 0-1 1v2a2 2 0 0 0 2 2h4a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM9 15a1 1 0 0 0 1 1h4a2 2 0 0 0 2-2V8a1 1 0 0 0-1-1h-5a1 1 0 0 0-1 1zM15 5a1 1 0 0 0 1-1V2a2 2 0 0 0-2-2h-4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1z" />
      </g>
    </svg>
  );
};
